import React from 'react';

interface Feature {
  number?: number;
  title: string;
  description: string;
  stat: string;
}

interface PlatformFeaturesProps {
  title?: string;
  features: Feature[];
}

const PlatformFeatures = ({ 
  title = 'Platform Features',
  features
}: PlatformFeaturesProps) => {
  return (
    <section className="container mx-auto px-4 py-16">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-foreground text-center mb-12">
          {title}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative p-6 rounded-2xl bg-card border border-border flex flex-col"
            >
              <div className="relative flex-1 flex flex-col">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#FAC72E] to-[#FA832E] flex items-center justify-center text-white mb-4 font-bold text-lg">
                  {String(feature.number !== undefined ? feature.number : index + 1).padStart(2, '0')}
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {feature.title}
                </h3>
                <p className="text-[#728F8B] mb-4 leading-relaxed flex-1">
                  {feature.description}
                </p>
                <div className="pt-4 border-t border-border mt-auto">
                  <div className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-circle-check-big w-4 h-4 text-[#FA832E]"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                    <span className="text-sm font-semibold text-[#FA832E]">
                      {feature.stat}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformFeatures;

